import InputVariableTable from './InputVariableTable';
import { InputVariableTableProps, InputVariableTableValueProps, InputVariableTableCombinedProps } from './types';

export type { InputVariableTableProps, InputVariableTableValueProps, InputVariableTableCombinedProps };
export default InputVariableTable;
